<form data-toggle="validator"
      (keydown.enter)="onLogin(loginForm.value)"
      [formGroup]="loginForm">
    <!-- Identity Input -->
    <app-input id="identity"
               [formControl]="control('identity')"
               [showErrors]="showErrors || (control('identity').touched && control('identity').invalid)"
               [placeholder]="'auth.emailLabel' | translate">
    </app-input>
    <app-input id="password"
               [formControl]="control('password')"
               [showErrors]="showErrors || (control('password').touched && control('password').invalid)"
               [placeholder]="'auth.passwordLabel' | translate"
               type="password">
    </app-input>

    <app-button type="primary"
                (clicked)="onLogin(loginForm.value)"
                [disabled]="loginForm.invalid || isLoading">{{ 'auth.buttons.login' | translate }}
    </app-button>

    <div id="loading-indicator-container">
        <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
    </div>

    <app-alert type="error" *ngIf="loginError" message="{{ 'auth.invalidCredentialsError' | translate }}">

    </app-alert>
</form>
